'use client'
import { SanityAssetDocument } from 'next-sanity'
import { styles, ImageHighlightVariants } from './ImageHighlight.css'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { AppTitle } from '@otomoro/components/shared/AppTitle'

interface ImageHighlightProps extends ImageHighlightVariants {
	image: SanityAssetDocument
	headline?: string
	logo?: {
		svg: string
	}
}

export const ImageHighlight: React.FC<ImageHighlightProps> = ({ image, headline, logo }) => {
	const { base, imageStyle, textOverlay, title, svgStyles } = styles()

	return (
		<section className={base()}>
			<SanityImage
				image={image.image}
				alt={image.alt || ''}
				sizes='(max-width: 768px) 80vw, (max-width: 1200px) 50vw, 60vw'
				className={imageStyle()}
			/>
			{logo && (
				<span className={svgStyles()} dangerouslySetInnerHTML={{ __html: logo.svg }} />
			)}
			<div className={textOverlay()}>
				<AppTitle
					variant="headlineBig"
					color="white"
					className={title()}
					textTransform="uppercase"
					textAlign="center"
				>
					{headline}
				</AppTitle>
			</div>
		</section>
	)
}
